import React from "react";

/**
 * What the two boxes are actually for.
 *
 * "Card edge" and "border" only mean something once you have been shown them;
 * asked cold, the honest answer is "which border?". One picture of a card with
 * the band called out settles it faster than any wording of the labels.
 *
 * Drawn rather than photographed so it stays legible small, needs no asset,
 * and can take its colours from the theme.
 */
export default function BorderDiagram({ compact = false }) {
  return (
    <figure className={`cen-diagram${compact ? " cen-diagram--compact" : ""}`}>
      <svg viewBox="0 0 210 150" role="img" aria-labelledby="cen-diagram-title">
        <title id="cen-diagram-title">
          A card, with the border band between its outer edge and its artwork
        </title>

        {/* the card, filled with the colour of the border band */}
        <rect x="8" y="10" width="96" height="132" rx="4" className="cen-dia-band" />
        {/* the artwork, which is where the band stops */}
        <rect x="20" y="24" width="72" height="104" rx="2" className="cen-dia-art" />

        {/* the two boxes, drawn as they appear on the photo */}
        <rect x="8" y="10" width="96" height="132" rx="4" className="cen-dia-outer" />
        <rect x="20" y="24" width="72" height="104" rx="2" className="cen-dia-inner" />

        {/* what each one is */}
        <line x1="104" y1="16" x2="128" y2="16" className="cen-dia-lead cen-dia-lead--outer" />
        <text x="132" y="19" className="cen-dia-key cen-dia-key--outer">Card edge</text>
        <text x="132" y="31" className="cen-dia-note">the outside of the card</text>

        <line x1="92" y1="120" x2="128" y2="120" className="cen-dia-lead cen-dia-lead--inner" />
        <text x="132" y="123" className="cen-dia-key cen-dia-key--inner">Border</text>
        <text x="132" y="135" className="cen-dia-note">where the band ends</text>

        {/* the band itself — the thing being measured */}
        <line x1="8" y1="75" x2="20" y2="75" className="cen-dia-span" />
        <text x="14" y="70" className="cen-dia-span-label" textAnchor="middle">
          this
        </text>
      </svg>
      <figcaption>
        The band between the two boxes is the border. Centering is whether it is the
        same thickness on opposite sides — thin on the left and fat on the right means
        the card was cut off-centre, and that is what caps the grade.
      </figcaption>
    </figure>
  );
}
